import { State, Action, StateContext, Selector } from '@ngxs/store';
import { LoadTasks } from '@app/_state/task.actions';
import { Task } from '@app/_models/task';
import { Injectable, inject } from '@angular/core';
import { BpmService } from '@app/_services/bpm.service';
import { tap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

export class TaskStateModel {
  public assignedTasks?: Task[];
  public candidateGroupTasks?: Task[];
}

@State<TaskStateModel>({
  name: 'task',
  defaults: {
    assignedTasks: [],
    candidateGroupTasks: [],
  }
})
@Injectable()
export class TaskState {
  private bpmService = inject(BpmService);


  @Selector()
  static assigned(state: TaskStateModel) : Task[] {
    return state.assignedTasks || [];
  }

  @Selector()
  static candidateGroup(state: TaskStateModel) : Task[] {
    return state.candidateGroupTasks || [];
  }

  @Action(LoadTasks)
  loadTasks(ctx: StateContext<TaskStateModel>, action: LoadTasks) {
    const o1 = this.bpmService.tasksCandidateOrAssigned(action.userId);
    const o2 = this.bpmService.tasksByCandidateGroup(action.groups);

    return forkJoin([o1, o2]).pipe(
      tap(result => {
        console.log(result);
        // ctx.setState({assignedTasks: result[0].data.filter(t => !t['suspended']), candidateGroupTasks: result[1].data.filter(t => !t['suspended'])});
      })
    );
  }
}
